module.exports = __webpack_public_path__ + "static/img/logo_blue.6973227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1/logo_blue.png
// module id = ze7W
// module chunks = 1